// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "c72e8dba4877011f92d185d05823e5eb656321e7/static/css/" + chunkId + "." + "9ae35b6f" + ".chunk.css";
};